module.exports = __webpack_public_path__ + "img/logo.b126690a.png";